import { useEffect, useRef, config, useState, Func } from '@/common'
import E from 'wangeditor'

function Main(props: any) {
    const ref = useRef<any>()
    const [editor, setEditor] = useState<any>()
    const [default_status, setDefaultStatus] = useState(true)

    useEffect(() => {
        setEditor(new E(ref.current))
    }, [])

    useEffect(() => {
        if (editor) {
            editor.config.uploadImgServer = config.api.url.default + '/resource/upload'
            editor.config.onchange = (html: any) => {
                props.onChange(html)
            }
            editor.config.uploadFileName = 'file'
            editor.config.uploadImgHooks = {
                customInsert: (insertImgFn: any, result: any) => {
                    if (!result.code) {
                        insertImgFn(Func.getRealUrl(result.data))
                    }
                }
            }
            editor.create()
            return () => {
                if (editor) {
                    editor.destroy()
                }
            }
        }
    }, [editor])

    useEffect(() => {
        if (default_status && props.value && editor) {
            editor.txt.html(props.value)
            setDefaultStatus(false)
        }
    }, [props.value])

    return (
        <div ref={ref}></div>
    )
}

export default Main